<template>
  <fluid-form-item :required="required" :label="label" :dialog="dialog">
    <v-text-field
      outlined
      dense
      :solo="solo"
      :flat="flat"
      :type="type"
      :max="max"
      :min="min"
      v-model="modelValue"
      :rules="computedRules"
      :disabled="disabled"
      :readonly="readonly"
      :maxlength="maxlength"
      :label="innerLabel"
      @input="valueInput"
    >
    </v-text-field>
    <p class="help-block" v-if="tips">{{ tips }}</p>
  </fluid-form-item>
</template>
<script>
  import FluidFormItem from "./FluidFormItem";
  import { required } from "../../../plugins/rules";

  export default {
    name: "MTextField",
    data() {
      return {
        modelValue: this.value
      };
    },
    model: {
      prop: "value",
      event: "input"
    },
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        required: true
      },
      type: {
        type: String,
        required: false,
        default: "text"
      },
      rules: {
        type: Array,
        required: false,
        default: () => {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        required: false
      },
      solo: {
        type: Boolean,
        required: false
      },
      flat: {
        type: Boolean,
        required: false
      },
      readonly: {
        type: Boolean,
        required: false
      },
      required: {
        type: Boolean,
        required: false
      },
      maxlength: {
        type: Number,
        required: false
      },
      max: {
        type: Number,
        required: false
      },
      min: {
        type: Number,
        required: false
      },
      tips: {
        type: String,
        required: false
      },
      dialog: {
        type: Boolean,
        required: false
      }
    },
    watch: {
      value: {
        handler(val) {
          this.modelValue = val;
        },
        immediate: true
      }
    },
    computed: {
      innerLabel() {
        return this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "sm" ? this.label : "";
      },
      computedRules() {
        let rules = this.rules.slice(); // 复制规则数组
        if (this.required) {
          rules.unshift(v => required(v, `请输入${this.label}`));
        }
        if (this.type === "number") {
          if (this.max !== undefined) {
            rules.push(v => v === undefined || v <= this.max || `最大值不能超过 ${this.max}`);
          }
          if (this.min !== undefined) {
            rules.push(v => v === undefined || v >= this.min || `最小值不能低于 ${this.min}`);
          }
        }
        return rules;
      }
    },
    components: { FluidFormItem },
    created() {},
    methods: {
      valueInput() {
        this.$emit("input", this.modelValue);
      }
    }
  };
</script>
